import React, { Component } from 'react'
import ExpiredAppsComponent from './ExpiredAppsComponent'
import { connect } from 'react-redux'
import { actions } from './ExpiredAppsReducer'
import moment from 'moment'
class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
    }
    render() {
        return (
            <ExpiredAppsComponent {...this.props} />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const dateToMoment = account => Object.assign({},{...account}, {last_login: moment(account.last_login).format('DD-MMM-YY, hh:mm:ss a')})
    const changeAccountsTime = accounts => accounts.map(account => dateToMoment(account));
    const accounts = changeAccountsTime(state.waas.expiredApps.items);
    return {
        accounts: accounts,
        page: state.waas.expiredApps.page,
        itemsPerPage: state.waas.expiredApps.itemsPerPage,
        itemsTotal: state.waas.expiredApps.itemsTotal,
        
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: () => dispatch(actions.trigger()),
        changeitemsPerPage: (val) => dispatch(actions.changeitemsPerPage(val)),
        pageChange: (val) => dispatch(actions.pageChange(val)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)